module.exports = __webpack_public_path__ + "img/gb925.prt.2767ea37.jpg";